// @ts-nocheck
/* eslint-enable */
// App
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Hooks
import { usePrevious } from 'app/shared/modules/MobileSRP/ListingCards/List/hooks';
import { useAds } from './useAds';

// Helpers
import {
  getAdvertisementConfigurationsHelper,
  getAdvertisementSlotIdsHelper,
} from 'app/shared/modules/AdvertisementWrapper/helpers';

// Misc / styles
import { SkeletonCard as AdvertisementSkeleton } from 'app/shared/modules/listing-cards/ListingCardV3';
import { ListingAdContainer, ListingAdListItem } from './styles';

const SLOT_1_INDEX = 2;
const SLOT_2_INDEX = 17;
const AdvertisementWrapper = ({ handleHideAdElement, children, hideSlot1, hideSlot2 }) => {
  // Redux
  const gadsInit = useSelector((state) => state.ads.gadsInit);
  const isClientLoaded = useSelector((state) => state.app.clientLoaded);
  const filter = useSelector((state) => state.filter);
  const shouldRefreshAdSlot1 = useSelector((state) => state.ads?.srpAdSlot1?.shouldRefresh);
  const shouldRefreshAdSlot2 = useSelector((state) => state.ads?.srpAdSlot2?.shouldRefresh);

  const [adConfig1, adConfig2] = getAdvertisementConfigurationsHelper(filter);
  const [adSlot1Id, adSlot2Id] = getAdvertisementSlotIdsHelper([adConfig1, adConfig2]);

  // Hooks
  const prevProps = usePrevious({ gadsInit, shouldRefreshAdSlot1, shouldRefreshAdSlot2 });
  const [defineAd, refreshAd, cleanUpAd] = useAds({
    handleHideAdElement,
    filter,
    registeredConfigurations: [adConfig1, adConfig2],
    registeredIds: [adSlot1Id, adSlot2Id],
  });

  // componentDidMount
  useEffect(() => {
    defineAd();

    return () => {
      // componentWillUnmount
      cleanUpAd();
    };
  }, []);

  // componentDidUpdate
  useEffect(() => {
    if (prevProps?.gadsInit === false && gadsInit === true) {
      defineAd();
    }
    if (
      (prevProps?.shouldRefreshAdSlot1 === false && shouldRefreshAdSlot1 === true) ||
      (prevProps?.shouldRefreshAdSlot2 === false && shouldRefreshAdSlot2 === true)
    ) {
      refreshAd([adConfig1?.placement, adConfig2?.placement]);
    }
  }, [gadsInit, shouldRefreshAdSlot1, shouldRefreshAdSlot2]);

  const AdOne = (
    <ListingAdListItem
      key={isClientLoaded ? `list-item-container-for-${adSlot1Id}` : `list-item-ad-container-for-${adSlot1Id}`}
    >
      {isClientLoaded ? <ListingAdContainer id={adSlot1Id} /> : <AdvertisementSkeleton />}
    </ListingAdListItem>
  );

  const AdTwo = (
    <ListingAdListItem
      key={isClientLoaded ? `list-item-container-for-${adSlot2Id}` : `list-item-ad-container-for-${adSlot2Id}`}
    >
      {isClientLoaded ? <ListingAdContainer id={adSlot2Id} /> : <AdvertisementSkeleton />}
    </ListingAdListItem>
  );

  const augmentedChildren = children.map((el) => ({ ...el }));

  if (!hideSlot1) {
    augmentedChildren.splice(SLOT_1_INDEX, 0, AdOne);
  }

  if (!hideSlot2) {
    augmentedChildren.splice(SLOT_2_INDEX, 0, AdTwo);
  }

  return augmentedChildren;
};

export default AdvertisementWrapper;
